import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-setting-lead-dialog',
  templateUrl: './setting-lead-dialog.component.html',
  styleUrls: ['./setting-lead-dialog.component.scss']
})
export class SettingLeadDialogComponent implements OnInit {
  @Input() leadPopup: boolean;
  @Input() message: string;
  @Input() popupHeader: string;
  @Input() paidByAdmin: boolean;

  @Output() confirmDialogToggle = new EventEmitter();
  constructor() { }

  ngOnInit() {
  }
  onClose(ev){
    this.confirmDialogToggle.emit(ev);
    // this.successcommon =false;
  }
}
